import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { dataServiceBaseUrl, dataService } from "../endpoints";
// Define a service using a base URL and expected endpoints
export const responsibilityCenterService = createApi({
  reducerPath: "responsibilityCenterService",
  baseQuery: fetchBaseQuery({ baseUrl: dataServiceBaseUrl }),
  tagTypes: ["ResponsibilityCenter"],
  endpoints: (builder) => ({
    getAllResponsibilityCenters: builder.mutation({
      query(body) {
        return {
          url: `${dataService.responsibilityCenterController.getAllResponsibilityCenters}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        }
      }
    }),
    getAllResponsibilityCentersWithSearch: builder.mutation({
      query(body) {
        return {
          url: `${dataService.responsibilityCenterController.getAllResponsibilityCentersWithSearch}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        }
      }
    }),
    getResponsibilityCenterById: builder.mutation({
      query(body) {
        return {
          url: `${dataService.responsibilityCenterController.getResponsibilityCenterById}/${body.id}`,
          method: "GET",
          headers: { Authorization: `Bearer ${body.token}`},
        };
      },
    }),
    saveResponsibilityCenter: builder.mutation({
      query(body) {
        return {
          url: `${dataService.responsibilityCenterController.saveResponsibilityCenter}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        }
      }
    }),
    updateResponsibilityCenter: builder.mutation({
      query(body) {
        return {
          url: `${dataService.responsibilityCenterController.updateResponsibilityCenter}/${body.payload.id}`,
          method: 'PUT',
          headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        }
      }
    }),
    deleteResponsibilityCenterById: builder.mutation({
      query(body) {
        return {
          url: `${dataService.responsibilityCenterController.deleteResponsibilityCenterById}/${body.id}`,
          method: 'DELETE',
          headers: { Authorization: `Bearer ${body.token}`},
        }
      }
    }),
    bulkSaveResponsibilityCenter: builder.mutation({
      query(body) {
        return {
          url: `${dataService.responsibilityCenterController.bulkSaveResponsibilityCenter}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        }
      }
    }),
  }),
});
export const {
  useGetAllResponsibilityCentersMutation,
  useGetAllResponsibilityCentersWithSearchMutation,
  useGetResponsibilityCenterByIdMutation,
  useSaveResponsibilityCenterMutation,
  useUpdateResponsibilityCenterMutation,
  useDeleteResponsibilityCenterByIdMutation,
  useBulkSaveResponsibilityCenterMutation
} = responsibilityCenterService;
